export default "/images/lock.svg?879c3784d96834cc7d978f25feff5a39";